export default "__VITE_ASSET__DCMNsDEQ__"